<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="module_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('module')">
                            <module-selectbox
                                :validateError="errors[0]"
                                value-type="id"
                                :ignoreAcademicYear="true"
                                v-model="formData.module_id">
                            </module-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="document_type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('document_type')">
                            <b-form-input :validate-error="errors[0]" v-model="formData.document_type"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="formData.file"
                                             :state="errors[0] ? false : (valid ? true : null)"
                                             :placeholder="$t('select_file')"
                                             :drop-placeholder="$t('drop_file')"
                                             accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                             ref="fileInput"
                                />
                                <b-button variant="outline-secondary"
                                          @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                </b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="start_date" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('start_date')">
                            <select-date v-model="formData.start_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="end_date" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('end_date')">
                            <select-date v-model="formData.end_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <b-form-input :validate-error="errors[0]" v-model="formData.status"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="createForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import PrepStudentDocumentService from "@/services/PrepStudentDocumentService";
    //Components
    import StudentsAutoComplete from "@/components/interactive-fields/StudentsAutoComplete.vue";
    import ModuleSelectbox from "@/components/interactive-fields/ModuleSelectbox.vue";

    export default {
        components: {
            ModuleSelectbox,
            ValidationProvider,
            ValidationObserver,

            StudentsAutoComplete,
        },
        data() {
            return {
                formLoading: false,
                formData: {
                    student_program_id: null,
                    module_id: null,
                    document_type: null,
                    file: null,
                    start_date: null,
                    end_date: null,
                    status: null,
                },
                user: null
            }
        },
        mounted() {
            this.user = this.$store.getters['auth/getUser'];
            if (this.user?.active_student_program?.id) {
                this.formData.student_program_id = this.user.active_student_program.id;
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;

                    const formData = new FormData();
                    formData.append("student_program_id", this.formData.student_program_id);
                    formData.append("module_id", this.formData.module_id);
                    formData.append("document_type", this.formData.document_type);
                    formData.append("start_date", this.formData.start_date);
                    formData.append("end_date", this.formData.end_date);

                    if (this.formData.status) {
                        formData.append('status', this.formData.status)
                    }

                    if (this.formData.file) {
                        formData.append('file', this.formData.file)
                    }

                    PrepStudentDocumentService.store(formData)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                    })
                                    .catch((error) => {
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    }).finally(() => {
                        this.formLoading = false;
                    });
                }
            },
            handleSelection(user) {
                this.formData.student_program_id = user?.student_program_id;
            },
        }
    }
</script>
